import Komoditas from '../components/komoditas/Komoditas';

function KomoditasView() {
  return (
    <div
      className="content-layout-container"
    >
      <Komoditas />
    </div>
  )
}

export default KomoditasView;